module.exports = __webpack_public_path__ + "img/booking-engine-logo.12d9b71b.svg";